import NewsweekWidget from './NewsweekWidget';

export default NewsweekWidget;
